export default __webpack_public_path__ + "media/images/images/gallery/9-2f9f15689fd822c535badace27e235ee.jpg";